import { render } from "./OsdComponent.vue?vue&type=template&id=afc2c160"
import script from "./OsdComponent.vue?vue&type=script&lang=js"
export * from "./OsdComponent.vue?vue&type=script&lang=js"

import "./OsdComponent.vue?vue&type=style&index=0&id=afc2c160&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__